import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useHistory, useParams } from "react-router";
import { Grid, Header, Image, Modal, Segment, Loader } from "semantic-ui-react";
import { message, Skeleton } from "antd";
import logo from "../../assets/images/logo_sef.png";
import SideNav from "../common/SideNav";
import { Switch, Route } from "react-router-dom";
import EmployeesData from "../users/Employees/EmployeesData";
import TopNav from "../common/TopNav";
import axios from "axios";
import StudentsData from "../users/Students/StudentsData";
import jwt from "jsonwebtoken";
import EditProfileForm from "../users/Users/EditProfileForm";
import Dashboard from "./Dashboard";
import { docTitle } from "../../helpers/docTitle";

const DashboardLayout = () => {
  let history = useHistory();
  let { schoolId } = useParams();
  const [item, setItem] = useState("");
  const [openDialog, setOpen] = useState({ open: false, reason: false });
  const [school, setSchool] = useState({});
  const [loggedUser, setUser] = useState({});
  const [pageLoad, setLoad] = useState(false);

  const [isUpdated, setUpdated] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        // const isUser = jwt.verify(token, "success");
        // console.log("isUser", isUser,);
        setLoad(true);
        // if (isUser.role !== "admin") {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/users`,
          { headers: { token } }
        );
        if (response.status === 200) {
          setLoad(false);
          setUser(response.data.data);
          await fetchSchool();
          return;
        }
        // return;
        // }
        // await fetchSchool();
      } catch (error) {
        console.log(error);
        return error;
      }
    };
    fetchData();
  }, [isUpdated]);

  const fetchSchool = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/schools/${schoolId}`,
        { headers: { token } }
      );

      setSchool(() => response.data.data);
    } catch (error) {
      console.log("error", schoolId);
      return error;
    }
  };
  docTitle(`${school.schoolName ? school.schoolName : "School"} - SEF`);

  const handleItemClick = async (e, { name }) => {
    setItem(name);
  };

  const handleModal = (reason) => {
    setOpen({ open: true, reason });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    history.push("/auth");
  };

  const handleDeleteAccount = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/users`,
        { headers: { token } }
      );
      if (response.status === 200) {
        handleLogout();
      }
    } catch (error) {
      return message.error(error.message);
    }
  };

  const navigateToSchool = () => {
    const token = localStorage.getItem("token");
    const user = jwt.verify(token, "success");
    return history.push(`/user/${user.uuid}`);
  };

  return (
    <>
      {pageLoad ? (
        <Loader active />
      ) : (
        <Grid padded>
          <Grid.Column width={3} verticalAlign="bottom">
            <Row>
              <Col className="d-flex justify-content-center">
                <Image src={logo} style={{ width: 100 }} />
              </Col>
            </Row>
            <Segment
              textAlign="center"
              color="dodge blue"
              className={school.image ? "" : "p-5"}
              style={{ cursor: loggedUser.role === "admin" ? "pointer" : "" }}
              onClick={loggedUser.role === "admin" ? navigateToSchool : null}
            >
              {!school.image ? (
                <Skeleton
                  avatar={{ size: "default" }}
                  active
                  paragraph={{ rows: 0 }}
                />
              ) : (
                <>
                  <Image src={school?.image} avatar size="mini" />
                  <Header content={school?.schoolName} as="h6" />
                </>
              )}
            </Segment>
            <SideNav
              item={item}
              handleClick={handleItemClick}
              handleModal={handleModal}
              schoolId={schoolId}
              user={loggedUser}
            />
          </Grid.Column>

          <Grid.Column
            stretched
            width={13}
            style={{ marginTop: 30, height: "90vh" }}
          >
            <Segment raised>
              <TopNav
                item={item}
                user={loggedUser}
                handleModal={handleModal}
                handleClick={handleItemClick}
                schoolId={schoolId}
                isUpdated={isUpdated}
                setUpdated={setUpdated}
              />
              <Grid textAlign="center" verticalAlign="middle">
                <Grid.Column textAlign="center">
                  <Modal
                    centered
                    basic
                    open={openDialog.open}
                    dimmer="blurring"
                    size="mini"
                    header={
                      openDialog.reason ? "Logging out" : "Delete Account"
                    }
                    content={
                      openDialog.reason
                        ? "Are you sure you want to log out?"
                        : "Are you sure you want to delete your account? This action cannot be undone."
                    }
                    actions={[
                      {
                        content: "Cancel",
                        negative: true,
                        onClick: () => setOpen(false),
                      },
                      {
                        content: "Done",
                        primary: true,
                        onClick: openDialog.reason
                          ? handleLogout
                          : async () => await handleDeleteAccount(),
                      },
                    ]}
                    style={{
                      position: "relative",
                      height: 200,
                    }}
                  />
                </Grid.Column>
              </Grid>
              <Switch>
                <Route
                  exact
                  path={`/dashboard/s/${schoolId}/`}
                  component={(props) => (
                    <Dashboard {...props} school={school} />
                  )}
                />
                <Route
                  exact
                  path={`/dashboard/s/${schoolId}/employees`}
                  component={(props) => (
                    <EmployeesData {...props} schoolId={schoolId} />
                  )}
                />
                <Route
                  path={`/dashboard/s/${schoolId}/students`}
                  component={(props) => (
                    <StudentsData {...props} school={school} />
                  )}
                />
                <Route
                  path={`/dashboard/s/${schoolId}/u/edit`}
                  component={(props) => (
                    <EditProfileForm
                      {...props}
                      schoolId={schoolId}
                      user={loggedUser}
                      isUpdated={isUpdated}
                      setUpdated={setUpdated}
                    />
                  )}
                />
              </Switch>
            </Segment>
          </Grid.Column>
        </Grid>
      )}
    </>
  );
};

export default DashboardLayout;
